module.exports = __webpack_public_path__ + "img/procedure_02_sp.aa4c0231.png";